package org.zq.astrock_ai.quant

import org.zq.astrock_ai.api.dto.KlineBarDto

fun KlineBarDto.toQuantBar(): QuantBar = QuantBar(
    date = date,
    open = open.toDouble(),
    high = high.toDouble(),
    low = low.toDouble(),
    close = close.toDouble(),
    volume = volume.toDouble(),
)

fun List<KlineBarDto>.toQuantBars(): List<QuantBar> = map { it.toQuantBar() }
